import { RouteConfig } from 'vue-router';

import EditEntryPage from '@/pages/index/pages/edit/EditEntryPage.vue';
import { refreshToken } from '@/router/guards/refreshToken';


export const editEntryPageRoute: RouteConfig = {
  beforeEnter: refreshToken,
  meta: {
    title: 'Edit Entry',
  },
  path: '/edit/:date',
  component: EditEntryPage,
};
